import { Box, Button, CircularProgress, SvgIcon, Typography } from '@mui/material';
import logo from '../Assets/logo192.png';
import { useCallback, useContext, useEffect, useState } from 'react';
import { AuthContext } from '../Context/AuthProvider';
import { signInWithRedirect, fetchUserAttributes } from 'aws-amplify/auth';
import { useNavigate } from 'react-router-dom';
import { apiWithAuth } from '../Services/Axios/axios';
import { url_api_int_profile_details } from '../RoutesMap';
if (window?.location?.pathname === '/login') {
  await import('./login.css');
}

const list = [
  "Lorem ipsum dolor sit amet consectetur adipisicing",
  "Lorem ipsum dolor sit amet consectetur adipisicing",
  "Lorem ipsum dolor sit amet consectetur adipisicing",
];

export default function LogIn() {
  const navigate = useNavigate();
  const { currentUser, fetchingUser, setCurrentUser } = useContext(AuthContext);

  const [loading, setLoading] = useState(true);

  const fetchUserInfo = useCallback(async () => {
    const userAttributes = await fetchUserAttributes();
    const response = await apiWithAuth.post(url_api_int_profile_details, {}, { headers: { "Content-Type": "multipart/form-data" } });
    if (response.data.status) {
      userAttributes['profile_image'] = response.data.data.user_profile_image;
    }
    setCurrentUser(userAttributes);
    return userAttributes;
  }, [setCurrentUser]);

  const getUser = useCallback(async () => {
    setLoading(true);
    try {
      await fetchUserInfo();
      navigate('/Interpreter/Dashboard');
    } catch (error) {
      setLoading(false);
    };
  }, [fetchUserInfo]);

  useEffect(() => {
    getUser();
  }, []);

  const handleLogin = async () => {
    await signInWithRedirect();
  }

  if (fetchingUser || loading) {
    return (
      <Box sx={{ width: '100svw', height: '100svh', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
        <CircularProgress size={40} color="secondary" />
      </Box>
    )
  }

  return (
    <Box sx={{
      width: '100svw',
      height: '100svh',
      overflow: 'hidden',
      bgcolor: '#fff',
    }}>
      <Box sx={{ width: '100%', height: '100svh', display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', gap: 3 }}>
        <Box sx={{
          width: '50%',
          height: 'calc(100svh - 48px)',
          display: { xs: 'none', lg: 'block' },
          bgcolor: '#f2f4f8',
          borderRadius: 1,
          p: 5,
          m: 3,
          mr: 0
        }}>
          <Box sx={{
            width: '100%',
            maxWidth: 600,
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            gap: 3
          }}>
            <Box component="img"
              src={logo}
              alt="brand-logo"
              sx={{ width: 70, objectFit: 'contain' }}
            />
            <Box sx={{ width: '100%', my: 'auto' }}>
              <Typography variant="h4" sx={{ fontWeight: 600, color: '#89ba40' }}>
                Lorem ipsum dolor sit amet consectetur adipisicing elit.
              </Typography>
              <Typography sx={{ color: '#666', mt: 2, fontWeight: 500 }}>
                Lorem ipsum dolor sit, amet consectetur adipisicing elit. Voluptas fugiat tempora odio distinctio iste expedita ab omnis
              </Typography>
            </Box>
            <Box sx={{
              width: '100%',
              px: 3,
              py: 5,
              borderRadius: 2,
              bgcolor: 'secondary.main',
              display: 'flex',
              flexDirection: 'column',
              gap: 1.5,
              position: 'relative',
              overflow: 'hidden'
            }}>
              <Box sx={{ position: 'absolute', bottom: -20, right: 0, opacity: 0.8 }}>
                <SvgIcon sx={{ fontSize: 80, color: '#f2f4f8' }}>
                  <path d="M9.813 15.904 9 18.75l-.813-2.846a4.5 4.5 0 0 0-3.09-3.09L2.25 12l2.846-.813a4.5 4.5 0 0 0 3.09-3.09L9 5.25l.813 2.846a4.5 4.5 0 0 0 3.09 3.09L15.75 12l-2.846.813a4.5 4.5 0 0 0-3.09 3.09ZM18.259 8.715 18 9.75l-.259-1.035a3.375 3.375 0 0 0-2.455-2.456L14.25 6l1.036-.259a3.375 3.375 0 0 0 2.455-2.456L18 2.25l.259 1.035a3.375 3.375 0 0 0 2.456 2.456L21.75 6l-1.035.259a3.375 3.375 0 0 0-2.456 2.456ZM16.894 20.567 16.5 21.75l-.394-1.183a2.25 2.25 0 0 0-1.423-1.423L13.5 18.75l1.183-.394a2.25 2.25 0 0 0 1.423-1.423l.394-1.183.394 1.183a2.25 2.25 0 0 0 1.423 1.423l1.183.394-1.183.394a2.25 2.25 0 0 0-1.423 1.423Z" />
                </SvgIcon>
              </Box>
              <Box sx={{ width: '100%', display: 'flex', flexDirection: 'column', gap: 1.5, zIndex: 1 }}>
                {list?.map((item, index) => (
                  <Box key={index} sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <Box sx={{ width: 8, height: 8, bgcolor: 'white', borderRadius: '50%' }} />
                    <Typography sx={{ color: '#f2f4f8' }}>{item}</Typography>
                  </Box>
                ))}
              </Box>
            </Box>
          </Box>
        </Box>
        <Box sx={{
          width: '100%',
          height: '100vh',
          overflow: 'hidden',
          flex: { lg: '0 0 50%' }
        }}>
          <Box sx={{ display: 'flex', flexDirection: 'column', width: '100%', height: '100%', gap: 2 }}>
            <Box sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: { xs: 'space-between', lg: 'flex-end' },
              p: 2
            }}>
              <Box
                component="img"
                src={logo}
                alt="brand-logo"
                sx={{
                  width: 60,
                  objectFit: 'contain',
                  display: { xs: 'block', lg: 'none' }
                }}
              />
            </Box>
            <Box sx={{
              width: '100%',
              height: '100%',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center'
            }}>
              <Box sx={{
                width: {
                  xs: '85%',
                  lg: '100%'
                },
                maxWidth: '600px',
                mx: 'auto',
                px: {
                  lg: 10
                }
              }}>
                <Typography variant="h4" sx={{ fontWeight: 600 }}>
                  Welcome back
                </Typography>
                <Typography
                  variant="h6"
                  sx={{
                    color: '#666',
                    fontWeight: 500,
                    my: 2
                  }}
                >
                  Login to continue
                </Typography>
                <Button
                  onClick={handleLogin}
                  sx={{
                    height: '48px',
                    width: '100%',
                    mt: 10,
                    bgcolor: 'secondary.main',
                    color: '#fff',
                    '&:hover': {
                      bgcolor: 'secondary.main',
                    }
                  }}
                >
                  Login
                </Button>
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}